import type { Widget } from "../types/widget";

/** Base-model fields auto-filled by the backend on create. */
export const WIDGET_IMPORT_STRIPPED_FIELDS = [
  "id",
  "createdBy",
  "createdDate",
  "lastModifiedDate",
  "lastModifiedBy",
  "tenant",
  "createdGroups",
] as const;

export type WidgetImportStrippedField = (typeof WIDGET_IMPORT_STRIPPED_FIELDS)[number];

export function sanitizeWidgetForImport(widget: Widget): Widget {
  const sanitized = { ...widget };
  for (const field of WIDGET_IMPORT_STRIPPED_FIELDS) {
    delete sanitized[field as keyof Widget];
  }
  return sanitized;
}
